import LogoFarm from 'react-scale/components/ui/logo-grid';

const Partners = ({ limit = 32 }) => (
  <section className="relative text-white">
    <div className="container">
      <LogoFarm
        text
        limit={limit}
        logos={[
          'brex',
          'etsy',
          'gm',
          'flexport',
          'instacart',
          'blend',
          'nvidia',
          'openai',
          'paypal',
          'sap',
          'square',
          'toyota',
          'airforce',
          'usarmy'
        ]}
        columns={{ xs: 4, sm: 4, md: 6, lg: 7 }}
      />
    </div>
  </section>
);

export default Partners;
